module.exports = __webpack_public_path__ + "fonts/dxiconsios.c54c6f15.woff2";